/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/schPayReceipts/schPayReceiptsActions";
import { useSchPayReceiptsUIContext } from "../SchPayReceiptsUIContext";

export function SchPayReceiptDeleteDialog({ id, show, onHide }) {
  // SchPayReceipts UI Context
  const schPayReceiptsUIContext = useSchPayReceiptsUIContext();
  const schPayReceiptsUIProps = useMemo(() => {
    return {
      setIds: schPayReceiptsUIContext.setIds,
      queryParams: schPayReceiptsUIContext.queryParams,
    };
  }, [schPayReceiptsUIContext]);

  // SchPayReceipts Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schPayReceipts.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchPayReceipt = () => {
    // server request for deleting schPayReceipt by id
    dispatch(actions.deleteSchPayReceipt(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchPayReceipts(schPayReceiptsUIProps.queryParams));
      // clear selections list
      schPayReceiptsUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchPayReceipt Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schPayReceipt?</span>
        )}
        {isLoading && <span>SchPayReceipt is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchPayReceipt}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
